import { render, staticRenderFns } from "./IYBTrafficLightPanel.vue?vue&type=template&id=6e9715f3&scoped=true"
import script from "./IYBTrafficLightPanel.vue?vue&type=script&lang=js"
export * from "./IYBTrafficLightPanel.vue?vue&type=script&lang=js"
import style0 from "./IYBTrafficLightPanel.vue?vue&type=style&index=0&id=6e9715f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9715f3",
  null
  
)

export default component.exports